import { QuestionStatus } from '@exam-management/graphql';
import { Flex, PaperSection } from '@shared/components';

import { LocationSectionWrapper } from '../../components';
import { LocationSection } from '../location-section';
import { SingleQuestionsInLocationSection } from '../single-questions-in-location-section';

interface QContentDetailsSectionProps {
  questionId?: string;
  questionStatus?: QuestionStatus;
  readonly?: boolean;
  refQBankStructureId?: string;
}

export default function QContentLocationSection(props: Readonly<QContentDetailsSectionProps>) {
  const {
    readonly: isReadonly = false,
    questionStatus = QuestionStatus.Draft,
    questionId,
    refQBankStructureId,
  } = props;

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4), width: '100%' }}>
      <PaperSection title='Location'>
        <LocationSectionWrapper>
          <LocationSection readonly={isReadonly} questionStatus={questionStatus} />
        </LocationSectionWrapper>
      </PaperSection>
      {[QuestionStatus.PreDraft, QuestionStatus.InReview, QuestionStatus.InDevelopment].includes(
        questionStatus,
      ) ? null : (
        <SingleQuestionsInLocationSection
          questionId={questionId}
          refQBankStructureId={refQBankStructureId}
        />
      )}
    </Flex>
  );
}
